import { Paper } from '@mui/material'
import React from 'react'

export default function CardWithBorder({children}) {
  return (
<Paper
                  elevation={3}
                  sx={{
                    p: 3,
                    borderRadius: 3,
                    bgcolor: "#fdfefe",
                    border: "1px solid #e0e0e0",
                    boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
                  }}
                > 
                {children}
                </Paper>
  )
}
